import { axiosInstance } from "@/lib/axios";
import type { HeroSlide } from "@/types/settings.types";

const BASE_URL = "/settings/hero-slide";

// Plain data, kept in this non-"use client" module so Server Components
// (e.g. app/(client)/page.tsx) can import it directly for prefetching.
export const carouselQueryKeys = {
    all: ["carousel"] as const,
    heroSlides: () => [...carouselQueryKeys.all, "hero-slides"] as const,
};

// ===============================
// GET ALL HERO SLIDES
// ===============================
export const getHeroOptions = async (): Promise<HeroSlide[]> => {
    const { data } = await axiosInstance.get(BASE_URL);
    return data.data;
};

// ===============================
// ADD HERO SLIDE
// ===============================
export const addHeroSlide = async (payload: FormData): Promise<HeroSlide> => {
    const { data } = await axiosInstance.post(BASE_URL, payload, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
    return data.data;
};

// ===============================
// UPDATE HERO SLIDE
// ===============================
export const updateHeroSlideAdmin = async (
    id: string,
    payload: FormData
): Promise<HeroSlide> => {
    const { data } = await axiosInstance.put(`${BASE_URL}/${id}`, payload, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
    return data.data;
};

// ===============================
// DELETE HERO SLIDE
// ===============================
export const deleteHeroSlideAdmin = async (id: string): Promise<void> => {
    await axiosInstance.delete(`${BASE_URL}/${id}`);
};
